import type { Components, Theme } from "@mui/material/styles";

export const MuiCardActions: Components<Theme>["MuiCardActions"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: theme.spacing(2, 3, 3),
    }),
  },
};
